//#region src/index.ts
const prefix = "USC/";
const separator = ",";
const UscAlgorithm = { compress(rawString) {
	let compressedString = prefix;
	if (rawString.length === 0) return compressedString;
	let savedCharacter = rawString[0];
	let savedCharacterCount = 0;
	for (let i = 0; i < rawString.length; i += 1) {
		const currentCharacter = rawString[i];
		if (currentCharacter === savedCharacter) savedCharacterCount += 1;
		else {
			compressedString += savedCharacter + savedCharacterCount.toString() + separator;
			savedCharacter = currentCharacter;
			savedCharacterCount = 1;
		}
	}
	compressedString += savedCharacter + savedCharacterCount.toString();
	return compressedString;
} };
var src_default = UscAlgorithm;

//#endregion
export { src_default as default };